import React, { createContext, ReactNode, useContext } from 'react';
import { QueueStore } from '../queues/store/queue-store';
import { BoloQueueView } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import { useBoloQueueWorkspacePanel } from '../common/hooks/use-bolo-queue-workspace-panel';
import { assertNonNull } from '../queues/utils/assert-non-null';
import { useIntegratedBoloQueueStore } from '../bolos/bolo-queues/use-integrated-bolo-queue-store';
import { useEnabledFeatures } from '../common/hooks/enabled-features';
import { WorkspacePanelProvider } from '../panels/workspace-panel-provider';

export const FrBoloQueueStoreContext = createContext<QueueStore<BoloQueueView> | null>(null);

export function useFrBoloQueueStoreProvider() {
    const ctx = useContext(FrBoloQueueStoreContext);
    return ctx;
}

const FrBoloQueueProvider = ({ children }: { children: ReactNode }) => {
    const bolosWorkspacePanel = useBoloQueueWorkspacePanel();
    assertNonNull(bolosWorkspacePanel, 'Workspace for queue and entity type BOLO not found');

    const boloQueueStore = useIntegratedBoloQueueStore() as unknown as QueueStore<BoloQueueView>;

    return (
        <FrBoloQueueStoreContext.Provider value={boloQueueStore}>
            {children}
        </FrBoloQueueStoreContext.Provider>
    );
};

const FrBoloQueueDisabledProvider = ({ children }: { children: ReactNode }) => {
    return (
        <FrBoloQueueStoreContext.Provider value={null}>{children}</FrBoloQueueStoreContext.Provider>
    );
};

export const FrBoloQueueStoreProvider = observer(function FrBoloQueueStoreProvider(props: {
    children: ReactNode;
}) {
    const { viewBolos: bolosEnabled } = useEnabledFeatures();
    const bolosWorkspacePanel = useBoloQueueWorkspacePanel();

    return !bolosEnabled || !bolosWorkspacePanel ? (
        <FrBoloQueueDisabledProvider>{props.children}</FrBoloQueueDisabledProvider>
    ) : (
        <WorkspacePanelProvider workspacePanel={bolosWorkspacePanel}>
            <FrBoloQueueProvider>{props.children}</FrBoloQueueProvider>
        </WorkspacePanelProvider>
    );
});
